import { ModalController } from '@ionic/angular';

export async function safeModalDismiss(modalController: ModalController): Promise<void> {
  const topModal = await modalController.getTop();
  if (topModal) {
    await modalController.dismiss();
  }
}
